/*
 * Soul Skin — search.
 * <soulskin-search>: sort, filter dropdowns and quick "Add" on the search page.
 * <soulskin-search-panel>: the header search overlay with instant results
 * from /search/suggest.json. Lives inside dialog-component#search-modal.
 */
(function () {
  function addToCart(btn) {
    if (btn.classList.contains('is-added') || btn.disabled) return;
    var label = btn.querySelector('[data-add-label]');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variant), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          if (label) label.textContent = original;
        }, 2200);
      })
      .catch(function () {
        btn.disabled = false;
        window.location.href = btn.dataset.url;
      });
  }

  if (!customElements.get('soulskin-search')) {
    customElements.define('soulskin-search', class extends HTMLElement {
      connectedCallback() {
        var sort = this.querySelector('[data-sort]');
        if (sort) {
          sort.addEventListener('change', function () {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', sort.value);
            url.searchParams.delete('page');
            window.location.href = url.toString();
          });
        }
        var self = this;
        document.addEventListener('click', function (e) {
          self.querySelectorAll('details.sks-filter[open]').forEach(function (d) {
            if (!d.contains(e.target)) d.removeAttribute('open');
          });
        });
        this.addEventListener('click', function (e) {
          var btn = e.target.closest('.sks-add[data-variant]');
          if (btn) {
            e.preventDefault();
            addToCart(btn);
          }
        });
      }
    });
  }

  if (customElements.get('soulskin-search-panel')) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  customElements.define('soulskin-search-panel', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-input]');
      this.clearBtn = this.querySelector('[data-clear]');
      this.idle = this.querySelector('[data-idle]');
      this.results = this.querySelector('[data-results]');
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.suggestUrl = this.dataset.suggestUrl || '/search/suggest';
      this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });
      this.timer = null;
      this.controller = null;
      this.lastTerm = '';
      if (window.matchMedia('(max-width: 749px)').matches) this.input.placeholder = 'Search products or brands';

      var self = this;
      this.dialogHost = this.closest('dialog-component');

      this.input.addEventListener('input', function () { self.onInput(); });
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = self.querySelector('[data-results]:not([hidden]) a, [data-idle]:not([hidden]) a');
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        if (e.target === self.input) return;
        var links = Array.prototype.slice.call(self.querySelectorAll('[data-body] a')).filter(function (a) {
          return a.offsetParent !== null;
        });
        var i = links.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        if (e.key === 'ArrowDown' && links[i + 1]) links[i + 1].focus();
        if (e.key === 'ArrowUp') (i === 0 ? self.input : links[i - 1]).focus();
      });

      this.querySelector('form').addEventListener('submit', function (e) {
        if (!self.input.value.trim()) e.preventDefault();
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          self.input.value = '';
          self.onInput();
          self.input.focus();
        });
      }

      this.querySelectorAll('[data-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });

      if (this.dialogHost) {
        this.dialogHost.addEventListener('dialog:open', function () {
          setTimeout(function () { self.input.focus({ preventScroll: true }); }, 30);
        });
      }
    }

    close() {
      if (this.dialogHost && typeof this.dialogHost.closeDialog === 'function') this.dialogHost.closeDialog();
      else {
        var d = this.closest('dialog');
        if (d) d.close();
      }
    }

    onInput() {
      var term = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = term.length === 0;
      clearTimeout(this.timer);
      if (term.length < 2) {
        if (this.controller) this.controller.abort();
        this.lastTerm = '';
        this.results.hidden = true;
        this.results.innerHTML = '';
        this.idle.hidden = false;
        return;
      }
      var self = this;
      this.timer = setTimeout(function () { self.fetchResults(term); }, 160);
    }

    allUrl(term) {
      return this.searchUrl + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
    }

    fetchResults(term) {
      if (term === this.lastTerm) return;
      this.lastTerm = term;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.results.classList.add('is-loading');
      var url = this.suggestUrl + '.json?q=' + encodeURIComponent(term) +
        '&resources%5Btype%5D=product%2Cquery&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title%2Ctag';
      var self = this;
      fetch(url, { signal: this.controller.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { self.render(term, (data && data.resources && data.resources.results) || {}); })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          self.render(term, {});
        });
    }

    image(src) {
      if (!src) return '';
      try {
        var u = new URL(src, window.location.origin);
        u.searchParams.set('width', '160');
        return u.toString();
      } catch (e) {
        return src;
      }
    }

    row(p) {
      var price = parseFloat(p.price);
      var was = parseFloat(p.compare_at_price_max);
      var sale = was > price;
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      var priceHtml = p.available === false
        ? '<span class="ss-row__price ss-row__price--off">Sold out</span>'
        : '<span class="ss-row__price' + (sale ? ' is-sale' : '') + '">' + esc(this.money.format(price)) +
          (sale ? '<s>' + esc(this.money.format(was)) + '</s>' : '') + '</span>';
      return '<a class="ss-row' + (p.available === false ? ' ss-row--off' : '') + '" href="' + esc(p.url) + '">' +
        '<span class="ss-row__img">' + (img ? '<img src="' + esc(this.image(img)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="ss-row__text"><span class="ss-row__brand">' + esc(p.vendor) + '</span>' +
        '<span class="ss-row__title">' + esc(p.title) + '</span></span>' + priceHtml + '</a>';
    }

    render(term, res) {
      if (term !== this.input.value.trim()) return;
      this.results.classList.remove('is-loading');
      var products = res.products || [];
      var queries = (res.queries || []).filter(function (q) {
        return q.text && q.text.toLowerCase() !== term.toLowerCase();
      }).slice(0, 4);
      var html = '';
      if (products.length) {
        if (queries.length) {
          html += '<div class="ss-search__chips ss-search__chips--suggest">' + queries.map(function (q) {
            return '<a class="ss-search__chip" href="' + esc(this.allUrl(q.text)) + '">' + esc(q.text) + '</a>';
          }, this).join('') + '</div>';
        }
        html += '<p class="ss-search__label">Products</p><div class="ss-search__list">' +
          products.map(this.row, this).join('') + '</div>' +
          '<a class="ss-search__all" href="' + esc(this.allUrl(term)) + '">See all results for &ldquo;' + esc(term) +
          '&rdquo; <span aria-hidden="true">&rarr;</span></a>';
        this.idle.hidden = true;
      } else {
        html = '<div class="ss-search__none"><strong>No matches for &ldquo;' + esc(term) + '&rdquo;</strong>' +
          '<span>Try a brand like COSRX, or an ingredient like niacinamide.</span></div>';
        this.idle.hidden = false;
      }
      this.results.innerHTML = html;
      this.results.hidden = false;
    }
  });
})();